// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"86":"c605ebc47846d005b300","827":"61328cccc4d61aef4b07"}[chunkId] + ".js";
};